import { type IconProp, type BannerMessage, type SuggestedFeature } from './types';
import { FormattedMessage } from 'react-intl';
import RovoIcon from '@atlaskit/icon-lab/core/rovo';
import TeamsIcon from '@atlaskit/icon/core/teams';
import LockLockedIcon from '@atlaskit/icon/core/lock-locked';
import SendIcon from '@atlaskit/icon/core/send';
import CustomizeIcon from '@atlaskit/icon/core/customize';

export const BANNER_MESSAGES: Record<
	SuggestedFeature,
	Record<BannerMessage, React.ReactElement>
> = {
	Plans: {
		heading: (
			<FormattedMessage
				id="growth-luna.jira-recommend-retrial.banner.title.plans"
				defaultMessage="See all your timelines in one plan"
				description="Banner title for suggested Plans paid feature"
			/>
		),
		cta: (
			<FormattedMessage
				id="growth-luna.jira-recommend-retrial.banner.cta.plans"
				defaultMessage="Create a plan"
				description="Banner CTA for suggested Plans paid feature"
			/>
		),
	},
	Permissions: {
		heading: (
			<FormattedMessage
				id="growth-luna.jira-recommend-retrial.banner.title.permissions"
				defaultMessage="Keep work secure"
				description="Banner title for suggested Permissions paid feature"
			/>
		),
		cta: (
			<FormattedMessage
				id="growth-luna.jira-recommend-retrial.banner.cta.permissions"
				defaultMessage="Set up permissions"
				description="Banner CTA for suggested Permissions paid feature"
			/>
		),
	},
};

export const MODAL_HEADING_MESSAGES: Record<SuggestedFeature, React.ReactElement> = {
	Plans: (
		<FormattedMessage
			id="growth-luna.jira-recommend-retrial.placement.suggested-feature.plans"
			defaultMessage="See all your timelines in one plan"
			description="Heading for suggested Plans paid feature"
		/>
	),
	Permissions: (
		<FormattedMessage
			id="growth-luna.jira-recommend-retrial.placement.suggested-feature.permissions"
			defaultMessage="Keep work secure and organized"
			description="Heading for suggested Permissions paid feature"
		/>
	),
};

export const FEATURE_MESSAGES: Record<
	SuggestedFeature,
	Array<{ id: string; icon: IconProp; message: React.ReactElement }>
> = {
	Plans: [
		{
			id: 'growth-luna.jira-recommend-retrial.plans.team-progress',
			icon: TeamsIcon,
			message: (
				<FormattedMessage
					id="growth-luna.jira-recommend-retrial.plans.team-progress"
					defaultMessage="See every team's progress in one place"
					description="Description for seeing team progress feature"
				/>
			),
		},
		{
			id: 'growth-luna.jira-recommend-retrial.plans.break-into-steps',
			icon: RovoIcon,
			message: (
				<FormattedMessage
					id="growth-luna.jira-recommend-retrial.plans.break-into-steps"
					defaultMessage="Break plans into achievable steps with AI"
					description="Description for breaking plans into achievable steps with AI feature"
				/>
			),
		},
		{
			id: 'growth-luna.jira-recommend-retrial.plans.customize-view',
			icon: CustomizeIcon,
			message: (
				<FormattedMessage
					id="growth-luna.jira-recommend-retrial.plans.customize-view"
					defaultMessage="Customize your view to suit you"
					description="Description for customizing your view feature"
				/>
			),
		},
	],
	Permissions: [
		{
			id: 'growth-luna.jira-recommend-retrial.permissions.assign-roles',
			icon: TeamsIcon,
			message: (
				<FormattedMessage
					id="growth-luna.jira-recommend-retrial.permissions.assign-roles"
					defaultMessage="Assign roles for groups, teams, or individuals"
					description="Description for assigning roles feature"
				/>
			),
		},
		{
			id: 'growth-luna.jira-recommend-retrial.permissions.set-custom-permissions',
			icon: LockLockedIcon,
			message: (
				<FormattedMessage
					id="growth-luna.jira-recommend-retrial.permissions.set-custom-permissions"
					defaultMessage="Set custom permissions for each role"
					description="Description for setting custom permissions feature"
				/>
			),
		},
		{
			id: 'growth-luna.jira-recommend-retrial.permissions.allow-customer-submissions',
			icon: SendIcon,
			message: (
				<FormattedMessage
					id="growth-luna.jira-recommend-retrial.permissions.allow-customer-submissions"
					defaultMessage="Allow customers to submit bugs and requests"
					description="Description for allowing customer submissions feature"
				/>
			),
		},
	],
};
